<div class="filter-container"
     [@openClose]="filtersOpened && phoneNumberFilterOpened ? 'open' : 'closed'"
     (clickOutside)="exitFilter($event)">
  <div class="filter-header">
    <a href="#" (click)="backToFilters()">
      <i class="material-icons">arrow_back</i>
    </a>
    <div>{{translateFilterName(filterOpenedName) | translate}}</div>
    <a href="#" (click)="filtersResign()"><i class="datatable-icon-close"></i></a>
  </div>
  <div class="filter-body">
    <div [formGroup]="clientPhoneNumbersForm" class="filter-body-form-wrapper">
      <div class="filter-body-item search-field">
        <cc-intl-phone-number-input formControlName="clientPhoneNumber"
                                    (keydown.enter)="createFilter()"
                                    [class.errored]="isNotValid()"></cc-intl-phone-number-input>
        <cc-input-errors
          [form]="clientPhoneNumbersForm"
          [inputName]="'clientPhoneNumber'"
          [errors]="[{'phone': 'ERRORS.PHONE'}, {'required': 'ERRORS.REQUIRED'}]"
        ></cc-input-errors>
        <button class="filter-phone-number-btn" (click)="createFilter()" [class.disabled]="isNotValid()">{{'ADD' | translate}}</button>
      </div>
      <div *ngFor="let item of phoneNumbersList" class="form-numbers-list-wrapper">
        <div class="filter-body-item">
            <span
              [ngClass]="[item.countryCode ? ('flag-icon-' + getCountryCode(item.name)): 'd-none']"
              class="pull-left flag-icon flag centred-vertical"></span>
            <span class="item-name">{{item.name | phoneNumber}}</span>
          <i class="material-icons close-icon" (click)="removeFilterRange(item)">close</i>
        </div>
      </div>
    </div>
  </div>
  <div class="filter-footer" (click)="phoneNumbersFiltersDone()">
    <button class="accept-button" [disabled]="!isFilteringReady">{{'DONE' | translate}}</button>
  </div>
</div>
